module.exports = __webpack_public_path__ + "static/project-19a-d85fed34689941c9a3cfb9324e3fa916.png";